import { Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import RequiredLabel from 'components/RequiredLabel'
import Seals from '../Seals'

const FUEL_TYPES = [
  { key: 'vlsfo', label: 'VLSFO', required: true },
  { key: 'hfo', label: 'HFO', required: true },
  { key: 'mdo', label: 'MDO', required: true },
  { key: 'ulsfo', label: 'ULSFO', required: false },
  { key: 'sludge', label: 'SLUDGE', required: true },
]

const SEAL_GROUPS = [
  {
    key: 'portside',
    label: 'Portside',
    rows: [
      { key: 'seal1', label: 'Seal No. 1' },
      { key: 'seal2', label: 'Seal No. 2' },
    ],
  },
  {
    key: 'starboard',
    label: 'Starboard',
    rows: [
      { key: 'seal1', label: 'Seal No. 1' },
      { key: 'seal2', label: 'Seal No. 2' },
    ],
  },
]

const SealsStep = () => {
  const { t } = useTranslation()

  return (
    <>
      <Seals
        columns={FUEL_TYPES}
        rowGroups={SEAL_GROUPS}
        rowHeader={t('rob.survey.seals.location')}
        title={t('rob.survey.seals.beforeBunkering')}
        fieldNameBuilder={({ group, row, column }) =>
          `general.seals.beforeBunkering.${group.key}.${column.key}.${row.key}`
        }
        renderCell={({ column, disabled, error, field, row }) => (
          <div className="seals__input-wrap">
            <Input
              {...field}
              disabled={disabled}
              placeholder={row.label}
              status={error ? 'error' : ''}
            />
            {column.required && <RequiredLabel required />}
          </div>
        )}
      />

      <Seals
        columns={FUEL_TYPES}
        rowGroups={SEAL_GROUPS}
        rowHeader={t('rob.survey.seals.location')}
        showCopyAssistant
        title={t('rob.survey.seals.afterBunkering')}
        copySourceFieldNameBuilder={({ group, row, column }) =>
          `general.seals.beforeBunkering.${group.key}.${column.key}.${row.key}`
        }
        fieldNameBuilder={({ group, row, column }) =>
          `general.seals.afterBunkering.${group.key}.${column.key}.${row.key}`
        }
        renderCell={({ column, disabled, error, field, row }) => (
          <div className="seals__input-wrap">
            <Input
              {...field}
              disabled={disabled}
              placeholder={row.label}
              status={error ? 'error' : ''}
            />
            {column.required && <RequiredLabel required />}
          </div>
        )}
      />
    </>
  )
}

export default SealsStep
